import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TextDirection } from './textDirection';
import { AppState } from '../core/redux/appState';
import { css } from '@emotion/core';
import { Z_INDEX } from '../globalStyle/zIndex';
import { COLORS } from '../globalStyle/colors';
import { setLocaleAction } from './setLocaleAction';
import { strictEquals } from '../language/module';
import { onMobileDevice } from '../globalStyle/mediaQueries';


const styles = {
  root: css`
    position: fixed;
    z-index: ${Z_INDEX.RTL_TOGGLE};
    border-color: ${COLORS.WHITE};
    border-radius: 10px;
    background-color: ${COLORS.DARK_GREY};
    color: ${COLORS.WHITE};
    right: 10px;
    bottom: 10px;
    padding: 15px 25px;
    text-transform: uppercase;
    
    ${onMobileDevice} {
      bottom: 80px;
    }

    &:hover { 
      background-color: ${COLORS.BLUE};
      cursor:pointer;
    }
  `,
};

type Props = {
  className?: string;
};


/**
 * RtlToggle: a component that renders a position-absolute toggle for RTL/LTR at the bottom-right of the screen
 *
 * PureComponent: true
 * Redux Connected: true
 */
const RtlToggle: React.FC<Props> = props => {
  const dispatch  = useDispatch();
  const direction = useSelector<AppState, TextDirection>(state => state.locale.textDirection, strictEquals);
  const show      = useSelector<AppState, boolean>(state => !!state.featureFlags?.showDebugRtlSelector, strictEquals);

  const toggleRtl = () => dispatch(
    setLocaleAction(undefined, direction === TextDirection.LTR ? TextDirection.RTL : TextDirection.LTR),
  );

  return show
    ? (
      <button
        onClick={toggleRtl}
        css={styles.root}
        className={props.className}
      >
        {direction}
      </button>
    )
    : null;
};

export default RtlToggle;
